export default "__VITE_ASSET__PIgpunmb__"